<template>
  <div class="container">
    <div class="row justify-content-center justify-lg-content-between">
      <div class="col-lg-6 d-flex flex-column">
        <div class="logos order-md-2">
          <slot name="logos"></slot>
        </div>
        <div class="content">
          <slot name="content"></slot>
        </div>
      </div>
      <div class="col-md-8 col-lg-5">
        <slot name="form"></slot>
        <div>
          <h3 style="font-weight: 700; font-size: 30px !important;">See How Fast We Can Get You Funded</h3>
          <img style="width: 100%" src="../../assets/imgs/American_Credit_Business_Loans.png" alt="American Credit Business loans the Difference You can Trust"/>
          <div style="text-align: center"><router-link to="/get-start?step=1" tag="button" class="cta">Get a quote</router-link></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
h2 {
  font-weight: 700;
  margin-bottom: 20px;
  font-size: 30px !important;
  font-family: "Biotif", "Helvetica", sans-serif;
  @media (min-width: 768px) {
    font-size: 36px !important;
  }
  span {
    color: #5456ff;
    font-family: "Biotif", "Helvetica", sans-serif;
  }
}

p {
  margin-bottom: 0;
  font-weight: 600;
}

.container {
  padding-top: 20px;
  padding-bottom: 40px;
  @media (min-width: 768px) {
    padding-top: 50px;
    padding-bottom: 80px;
  }

  @media (min-width: 1200px) {
  }
}

.content {
  p {
    color: #666;
  }
  @media (min-width: 1200px) {
    width: 75%;
  }
}

.logos {
  margin-bottom: 50px;

  @media (min-width: 768px) {
    margin-top: 20px;
    width: 85%;
  }

  img {
    max-width: 100%;
  }
}

.form-script {
  border: 2px solid #ccc;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  padding: 50px 40px;

  @media (max-width: 767px) {
    margin-top: 40px;
  }

  .hbspt-form {
    color: red;
  }

  .hs-button.primary {
    background-color: black !important;
  }
}
</style>



// WEBPACK FOOTER //
// FormSection.vue?308117bf